<template>
    <form >
        <div>
            <div>
                <ui-input
                    v-model="dataModel.phone"
                    type="text"
                    label="Telefone:"
                    mask="(##) ####-####"
                    size="md2"
                    :error="hasErrorPhone" 
                    :observation="messageErrorPhone"
                    @verify="(a,b)=> validateFieldPhone(a , b, 'Telefone:')"/>
            </div>
            <div>
                <ui-input
                    v-model="dataModel.mobile"
                    type="text"
                    label="Celular:"
                    mask="(##) #####-####"
                    size="md2" 
                    :error="hasErrorCellPhone" 
                    :observation="messageErrorCellPhone"
                    @verify="(a,b)=> validateFieldCellPhone(a , b, 'Celular:')"/>
            </div>
        </div>
    </form>
</template>

<script>
import { uiInput }   from '@/components/ui/form'

export default {
    name: 'ui-user-contact',
    components: {
        uiInput,
    },

    props: {
        userModel: {
            type: Object,
            default: () => {}
        },
    },

    data() {
        return {
            dataModel: this.userModel,
            isValidPhone:true,
            isValidCellPhone:true,
            hasErrorPhone: false,
            hasErrorCellPhone: false,
            messageErrorPhone:'',
            messageErrorCellPhone:''
        }
    },
    methods: {
        validateFieldPhone (event, inputValue, label) {
            this.isValidPhone = inputValue === '' || event

            if(!this.isValidPhone && label === 'Telefone:' ) {
                this.hasErrorPhone = true
                this.messageErrorPhone = 'Digite um número válido.'
            }else {
                this.hasErrorPhone = false
                this.messageErrorPhone = ''
            }  
        },
        validateFieldCellPhone (event, inputValue, label) {
            this.isValidCellPhone = inputValue === '' || event

            if(!this.isValidCellPhone && label === 'Celular:' ) {
                this.hasErrorCellPhone = true
                this.messageErrorCellPhone = 'Digite um número válido.'
            }else {
                this.hasErrorCellPhone = false
                this.messageErrorCellPhone = ''
            }  
        }
    }
    
}
</script>

<style lang='stylus' scoped>
    @import '../styles.styl'
</style>